/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, minutes: NonNullable<unknown> }} Features_Day_Plan_MetaInputs */

const en_features_day_plan_meta = /** @type {(inputs: Features_Day_Plan_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} exercises · about ${i?.minutes} min`)
};

const pl_features_day_plan_meta = /** @type {(inputs: Features_Day_Plan_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ćwiczeń · ok. ${i?.minutes} min`)
};

/**
* | output |
* | --- |
* | "{count} exercises · about {minutes} min" |
*
* @param {Features_Day_Plan_MetaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_day_plan_meta = /** @type {((inputs: Features_Day_Plan_MetaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Day_Plan_MetaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_day_plan_meta(inputs)
	return en_features_day_plan_meta(inputs)
});